export enum GridCellContentAlignment {
  Center = 'text-center',
  Left = 'text-left',
  Right = 'text-right',
}
